module.exports = {
	"naslov": "Vratio si se doma",
	"slika": "fotke/1941/1941-10-kragujevac-nemci-odvode-narod.jpg",
	"opis": "Žandarmi u službi okupatora odvode sve za koje sumnjaju da su Romi, Jevreji ili komunisti. Zakucali su na tvoja vrata.",
	"pitanje": "Šta će biti s tobom?",
	"akcija": "Baci kockicu da saznaš.",
	"ishodi": [
		{
			"naslov": "Koncentracioni logor",
			"opis": "Zarobljen si i odveden u koncentracioni logor. Tvoji izgledi za ostanak u životu postaju sve manji."
		},
		{
			"naslov": "Izvukao si se",
			"opis": "Vojnici su ti pretresli kuću, pregledali dokumenta, i nastavili."
		},
		{
			"mrtav": "mrtav",
			"opis": "Streljan si na dnu ulice u kojoj si živeo. Tvoja smrt je potpuno uzaludna."
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/hronologija/1941/05-10/podaci.json
// module id = 39
// module chunks = 0